import { WarrantyListItem } from './warranty-list-item.model';

export class WarrantyList {

    pageCount: number;
    rowCount: number;
    dataList: WarrantyListItem[] = [];
}
